import React from "react";
import {
  CardStyleInterpolators,
  createStackNavigator,
} from "@react-navigation/stack";

import LoginScreen from "../screens/LoginScreen";
import SignupScreen from "../screens/SignupScreen";
import ForgotPasswordScreen from "../screens/ForgotPasswordScreen";
import Header from "../components/Header";
import colors from "../config/colors";
import InfoWebScreen from "../screens/InfoWebScreen";
import OTPScreen from "../screens/OTPScreen";

const Stack = createStackNavigator();

const AuthNavigator = () => (
  <Stack.Navigator
    screenOptions={{
      cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
    }}
  >
    <Stack.Screen
      name="Login"
      component={LoginScreen}
      options={({ navigation }) => {
        return {
          headerTitle: () => (
            <Header navigation={navigation} title="BLUE CARD VISA" />
          ),
          headerStyle: {
            backgroundColor: colors.white,
          },
          headerTitleAlign: "center",
          headerTintColor: colors.primary,
        };
      }}
    />
    <Stack.Screen
      name="Signup"
      component={SignupScreen}
      options={({ navigation }) => {
        return {
          headerTitle: () => (
            <Header navigation={navigation} title="BLUE CARD VISA" />
          ),
          headerStyle: {
            backgroundColor: colors.white,
          },
          headerTitleAlign: "center",
          headerTintColor: colors.primary,
        };
      }}
    />
    <Stack.Screen
      name="Forgot"
      component={ForgotPasswordScreen}
      options={({ navigation }) => {
        return {
          headerTitle: () => (
            <Header navigation={navigation} title="BLUE CARD VISA" />
          ),
          headerStyle: {
            backgroundColor: colors.white,
          },
          headerTitleAlign: "center",
          headerTintColor: colors.primary,
        };
      }}
    />
    <Stack.Screen
      name="OTP"
      component={OTPScreen}
      options={({ navigation }) => {
        return {
          headerTitle: () => (
            <Header navigation={navigation} title="BLUE CARD VISA" />
          ),
          headerStyle: {
            backgroundColor: colors.white,
          },
          headerTitleAlign: "center",
          headerTintColor: colors.primary,
        };
      }}
    />
    <Stack.Screen
      name="Info"
      component={InfoWebScreen}
      options={({ navigation }) => {
        return {
          headerTitle: () => (
            <Header navigation={navigation} title="BLUE CARD VISA" />
          ),
          headerStyle: {
            backgroundColor: colors.white,
          },
          headerTitleAlign: "center",
          headerTintColor: colors.primary,
        };
      }}
    />
  </Stack.Navigator>
);

export default AuthNavigator;
